import {DateTime} from 'luxon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'

import { Emoji } from 'app/_shared'
import clsx from 'clsx'

import { reactions } from './Survey'
import styles from './Results.module.scss'

export default ({ results, className }) => {
  return (
    <div className={clsx(styles.results, className)}>
      { results.map((t, i) => (
        <div key={i} className={styles.result}>
          <div className={styles.name}>
            {t.userName}
          </div>
          <div className={styles.email}>
            {t.userEmail}
          </div>
          { t.guideDownloaded &&
            <div className={styles.guide}>
              <FontAwesomeIcon icon={faCheckCircle} />
              Guide last downloaded <span>{DateTime.fromISO(t.guideDownloaded).toLocaleString(DateTime.DATETIME_MED)}</span>.
            </div>
          }
          { t.rating &&
            <div className={styles.rating}>
              {reactions.map((s, i) => (
                <Emoji key={i} symbol={s} className={i + 1 === t.rating ? styles.active : undefined} />
              ))}
            </div>
          }
          { (t.rating || t.comment) &&
            <div className={styles.modified}>
              {DateTime.fromISO(t.lastUpdated).toLocaleString(DateTime.DATETIME_MED)}
            </div>
          }
          { t.comment &&
            <div className={styles.comments}>
              { t.comment && t.comment.split('\n').map((s, i) => (
                <p key={i}>{s}</p>
              ))}
            </div>
          }
        </div>
      ))}
    </div>
  )
}
